import Swiper, { Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

const slideshow = document.querySelector('#slideshow .swiper');

if (slideshow !== undefined && slideshow !== null) {
  new Swiper(slideshow, {
    loop: true,
    slidesPerView: 1,
    autoplay: { delay: 5000 },
    modules: [Navigation, Autoplay],
    navigation: {
      prevEl: slideshow.querySelector('.prev'),
      nextEl: slideshow.querySelector('.next'),
    },
  });
}
